import { Injectable } from '@angular/core';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { map } from 'rxjs/internal/operators/map';
import { createProfileConstants } from './constants/create-profile.constant';
import { RetailStoreConstants } from '../retail_api/constants/retailHq.constants';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class CreateProfileService {
  userId = sessionStorage.getItem('userId');
  resetSideNav = new Subject<boolean>();
  emitInstallationPackage = this.resetSideNav.asObservable();
  profileId: string;
  CREATE_PROFILE_URL = createProfileConstants.CREATE_PROFILE_USER + this.userId + createProfileConstants.PROFILE_ACTION;
  UPDATE_PROFILE_URL = createProfileConstants.PROFILE + createProfileConstants.USERS +
  this.userId + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH;
  GET_PROFILE_URL = createProfileConstants.PROFILE + createProfileConstants.USERS +
  this.userId + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH;
  UPDATE_LOGOCONTENT_ID = this.CREATE_PROFILE_URL + createProfileConstants.SLASH;
  GET_RETAIL_DATA_URL = RetailStoreConstants.SLASH_RETAILER_STORE +
  RetailStoreConstants.SLASH_RETAILER + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH
  + this.userId + RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SLASH;
  currentProfile: any = {}; // TO-DO: will be removed when data store will be created
  constructor(private httpMethodsservice: HttpMethodsService) { }

  createProfileInfo(configurationsJson: Object) {
    const url = createProfileConstants.CREATE_PROFILE_USER + sessionStorage.getItem('userId') + createProfileConstants.PROFILE_ACTION;

    return this.httpMethodsservice.post(url, configurationsJson)
      .pipe(map((res: any) => {
        this.currentProfile = res;

        return res;
      }
      ));
  }
  getProfile() {
    return this.currentProfile();
  }
  setProfile(data: any) {
    this.currentProfile = data;
  }

  // To do patch call for created profile.
  updateProfile(id: string, profileData: Object) {
    const url = createProfileConstants.PROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId') + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + id;

    return this.httpMethodsservice.patch(url, profileData)
      .pipe(map((res: any) =>
        res
      ));
  }

  getUpdatedProfileById(id: string) {
    const url = createProfileConstants.PROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId') + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + id;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>

        res
      ));
  }

  updateLogoContentId(profileId: string, data) {
    const url =  createProfileConstants.CREATE_PROFILE_USER + sessionStorage.getItem('userId')+ createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + profileId;

    return this.httpMethodsservice.patch(url, data)
      .pipe(map((res: any) =>
        res));
  }

  setProfileId(id: string) {
    this.profileId = id;
  }

  getProfileId() {
    return this.profileId;
  }

  updateProfileSegment(id: string, profileData: Object) {
    const url = createProfileConstants.PROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId')+ createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + id;

    return this.httpMethodsservice.patch(url, profileData)
      .pipe(map((res: any) =>

        res
      ));
  }

  updateProfileforPriceContent(id: string, profileData: Object) {
    const url = createProfileConstants.PROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId')+ createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + id;

    return this.httpMethodsservice.patch(url, profileData)
      .pipe(map((res: any) =>

        res
      ));
  }

  getAllSavedContentGroups(id: string) {
    const url = createProfileConstants.PROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId') + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + id;

    return this.httpMethodsservice.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getUserRoleData(userId: string, retailerId: string) {
    const url = RetailStoreConstants.SLASH_RETAILER_STORE +
    RetailStoreConstants.SLASH_RETAILER + RetailStoreConstants.SLASH_USER_ID + RetailStoreConstants.SLASH
    + sessionStorage.getItem('userId') + RetailStoreConstants.RETAILER_URL + RetailStoreConstants.SLASH + retailerId;

    return this.httpMethodsservice.get(url, false)
      .pipe(map((res: any) =>
        res));
  }

  getProfileDetailsById(profileId: string) {
    const URL = createProfileConstants.PROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId') + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + profileId;

    return this.httpMethodsservice.get(URL, false)
    .pipe(map((res: any) =>
      res));
  }
  getPubProfile(profileId: string){
    const URL = createProfileConstants.PUBPROFILE + createProfileConstants.USERS +
    sessionStorage.getItem('userId') + createProfileConstants.PROFILE_ACTION + createProfileConstants.SLASH + profileId;
    
    return this.httpMethodsservice.get(URL, false)
    .pipe(map((res: any) =>
      res));
  }

  emitPackageInstallation(data) {
    this.resetSideNav.next(data);
  }
}
